var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-select",
    {
      staticStyle: { width: "100%" },
      attrs: { placeholder: "请选择工单状态" },
      on: { change: _vm.ticketStatusChange_1 },
      model: {
        value: _vm.dataValue,
        callback: function($$v) {
          _vm.dataValue = $$v
        },
        expression: "dataValue"
      }
    },
    _vm._l(_vm.ticketStatusList, function(item) {
      return _c("el-option", {
        key: item.value,
        attrs: { label: item.name, value: item.value }
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6dae7b46", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6dae7b46","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ticket/TicketStatusSelect.vue
// module id = 974
// module chunks = 75